import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import {
  type ExtendedBuildingBlockNodeConfig,
  type ExtendedRootNodeConfig,
  NodeType,
} from '@nodeTypeConfig/configTypes';
import { proThemeTocTypes } from '@nodeTypeConfig/helpers/buildingBlocks/proThemeTocTypes';
import { proAliasesComponent } from '@nodeTypeConfig/helpers/editComponents/proAliasesComponent';
import { proContactsComponent } from '@nodeTypeConfig/helpers/editComponents/proContactsComponent';
import { proDocumentStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { proLinksAndMenuReferences } from '@nodeTypeConfig/helpers/editComponents/proLinksAndMenuReferences';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { proTileStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proTileStandardComponents';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import {
  proThemeDefaultValidationRules,
  proTileDefaultValidionRules,
} from '../proGenericConfigProps';

const proTextPageConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  information: {
    description:
      'Pro textPage (webTemplate code THEME_PAGE [not a very good name]) can be a SECTION (a tile) in a home or can be the root (single page pro theme)',
    single: 'PRO.-tegel: Tekstpagina',
    plural: "Tekstpagin's",
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  buildingBlocks: proDefaultBuildingBlocks,
  webTab: asideWebBasicConfiguration,
};

// Extends SECTION => A SECTION inside a Pro Theme and WebConfig THEME_PAGE becomes a PRO_TEXT_PAGE_TILE
export const PRO_TEXT_PAGE_TILE: ExtendedBuildingBlockNodeConfig = {
  ...proTextPageConfig,
  validationRules: [...proTileDefaultValidionRules],
  ...extendsSection,
  isCollapsedByDefault: true,
  edit: [
    ...proTileStandardComponents,
    proContactsComponent,
    proAliasesComponent,
    ...proLinksAndMenuReferences,
  ],
  addAccessRightsToAudienceTab: true,
  confirmDelete: true,
};

// Extends WEBPAGE2 => When adding THEME_PAGE WebConfig to a WEBPAGE2 it becomes a PRO_TEXT_PAGE_STANDALONE
export const PRO_TEXT_PAGE_STANDALONE: ExtendedRootNodeConfig = {
  ...proTextPageConfig,
  validationRules: [...proThemeDefaultValidationRules],
  information: {
    ...proTextPageConfig.information,
    definiteArticle: true,
    single: 'PRO.-thema: Tekstpagina',
  },
  extends: NodeType.WEBPAGE2,
  tocTypes: proThemeTocTypes,
  edit: [...proDocumentStandardComponents, proAliasesComponent, ...proLinksAndMenuReferences],
  audienceTab: proThemeAudienceTab,
  addAccessRightsToAudienceTab: true,
};
